<section class="landing-faq" id="faq">
  <div class="landing-faq__inner">
    <h2 class="landing-faq__title">{{ 'landing.faq.title' | translate }}</h2>

    <div class="landing-faq__container">
      <div class="faq-row" *ngFor="let key of keys; let i = index" [class.faq-row--first]="i === 0">
        <button type="button" class="faq-row__q" (click)="toggle(i)" [attr.aria-expanded]="openIndex === i">
          <span class="faq-row__text">{{ 'landing.faq.items.' + key + '.q' | translate }}</span>
          <span class="faq-row__sign" [class.faq-row__sign--open]="openIndex === i" aria-hidden="true">{{ openIndex === i ? '–' : '+' }}</span>
        </button>
        <div class="faq-row__a" *ngIf="openIndex === i" [innerHTML]="'landing.faq.items.' + key + '.a' | translate"></div>
      </div>
    </div>
  </div>
</section>
